// extracted by mini-css-extract-plugin
export default {"row":"e5wlpJo7zsnxflLzKGKw","meal":"DxvK_M5zmIR_tjv2FxB1"};